import React, { useState, useEffect } from "react";
import { Typewriter } from "react-simple-typewriter";
import "./Home.css";
import Testimonial from "./Test";
import { useNavigate } from "react-router-dom";
import Service from "../Service/SerServer";
import SService from "./SService";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import DetailService from "../DetailService/DetailService";
import AOS from "aos";
import OpacityLoading from "../Loading/OpacityLoading";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const images = [
  // "images/b1.png",
  // "images/b2.png",
  "images/b3.png",
  "images/b4.png",
  "images/b5.png",
  "images/b8.jpg",
  "images/b9.jpg",
  "images/b10.jpg",
  "images/b11.jpg",

  // Add more images as needed
];

function Home() {
  const [service] = useState(Service);
  const [counterOn, setCounterOn] = useState(false);
  const [modalOpen, setmodalOpen] = useState(false);
  const [select, setselect] = useState(null);

  const navigate = useNavigate();

  const Navigate = () => {
    navigate("contact_me");
  };
  const AboutHandlar = () => {
    navigate("/about");
  };

  const serviceHandelChange = () => {
    navigate("/service");
  };

  const ToggleModal = (item) => {
    setmodalOpen(!modalOpen);
    setselect(item);
  };

  let serviceDetail = null;
  if (modalOpen != null) {
    serviceDetail = <DetailService item={select} />;
  }

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const [currentImage, setCurrentImage] = useState(
    Math.floor(Math.random() * images.length)
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImage(Math.floor(Math.random() * images.length));
    }, 444000); // Change the interval as needed

    return () => clearInterval(intervalId);
  }, [currentImage]);

  return (
    <>
      <div>
        <OpacityLoading>
          {/* home top */}

          <div
            className=" background-image"
            // style={{ backgroundImage: `url(${images[currentImage]})` }}
          >
            <div className="top-home-banar ">
              <div className="top_banar1">
                <div className="t-home-text">
                  <h1>Hello , It's Me </h1>
                  <h2>Hasanul Haque Shiblu</h2>
                  <h3>
                    I am Expert in,
                    <br />
                    <br />
                    <span>
                      <Typewriter
                        words={[
                          " Web Design",
                          "Html & Css",
                          "C & Java",
                          "Web Development",
                          "React & Next js",
                          "Mern Stack",
                        ]}
                        loop="true"
                        cursor
                        cursorStyle="_"
                        typeSpeed={90}
                        deleteSpeed={50}
                        delaySpeed={1000}
                      />
                    </span>{" "}
                  </h3>
                  <p>
                    Web developer and Computer Science student at Daffodil
                    International University, Bangladesh, skilled in JavaScript,
                    and web frameworks.
                  </p>
                  <button className="Contact-me" onClick={Navigate}>
                    <span>Contact Me</span>
                  </button>
                </div>
              </div>
              <div className="t-home-picture">
                <svg viewBox="0 0 1000 700">
                  <g transform="translate(451.92721009196407 284.67519738484)">
                    <path fill="#008000">
                      <animate
                        attributeName="d"
                        dur="25000ms"
                        repeatCount="indefinite"
                        begin="0.9s"
                        values="
                          M140.9 -159.4C176.3 -138.1 194.5 -87.8 208 -33.4C221.5 21 230.3 79.5 211.2 130.9C192.2 182.2 145.3 226.4 86.6 255.3C27.9 284.1 -42.6 297.6 -79.4 264.2C-116.1 230.8 -118.9 150.6 -161.6 87.9C-204.3 25.2 -286.8 -20 -289.2 -58.8C-291.6 -97.5 -213.9 -130 -152.4 -146.6C-90.8 -163.3 -45.4 -164.1 3.6 -168.5C52.7 -172.8 105.4 -180.6 140.9 -159.4;
        M139.6 -169.8C183.3 -129.8 222.6 -88 231.3 -40.6C239.9 6.9 217.8 59.9 182.2 89.7C146.5 119.4 97.3 125.8 53.6 137.3C9.9 148.9 -28.2 165.6 -89.6 174.4C-151 183.2 -235.7 184.1 -286.2 142.9C-336.7 101.6 -353 18.3 -330.8 -49.7C-308.6 -117.7 -247.8 -170.3 -186.3 -207.1C-124.7 -243.9 -62.4 -265 -7.2 -256.4C48 -247.9 96 -209.7 139.6 -169.8;
        M131.5 -172.3C154.6 -137.3 146.5 -80.9 141.7 -35.7C136.8 9.4 135.1 43.2 127.6 90C120 136.8 106.7 196.7 68.9 226.6C31.1 256.5 -31.1 256.5 -100.8 245C-170.5 233.5 -247.6 210.5 -292.8 157C-338 103.6 -351.2 19.7 -318.7 -37.4C-286.2 -94.4 -208 -124.6 -147.3 -152.9C-86.6 -181.2 -43.3 -207.6 5.5 -214.1C54.2 -220.6 108.4 -207.2 131.5 -172.3;
        M113.4 -119C166.6 -90.6 242.9 -73.4 255.1 -39.7C267.3 -6 215.5 44.2 182 107.8C148.6 171.4 133.5 248.3 91.8 272C50.2 295.7 -18 266.2 -78.4 235.6C-138.9 204.9 -191.5 172.9 -238.7 122.6C-285.9 72.3 -327.6 3.6 -324.7 -65C-321.8 -133.5 -274.4 -202 -212.8 -229C-151.3 -255.9 -75.6 -241.5 -22.8 -214.4C30.1 -187.2 60.3 -147.5 113.4 -119;
        M169.4 -197.1C230 -151.1 296.7 -107.6 317 -47.7C337.2 12.1 311.1 88.3 271.9 157.7C232.7 227.1 180.5 289.8 125 284.4C69.5 279 10.7 205.6 -43.9 166C-98.5 126.4 -148.8 120.7 -172 93.2C-195.2 65.7 -191.1 16.3 -191.6 -42.9C-192 -102.2 -196.9 -171.4 -165.7 -222.5C-134.6 -273.7 -67.3 -306.8 -6.4 -299.2C54.4 -291.5 108.8 -243.1 169.4 -197.1;
        M157.2 -200.3C180.3 -168 159.4 -96.2 174.1 -28.4C188.7 39.4 239 103.2 236 162.4C233 221.6 176.7 276.2 107.1 307.1C37.5 338 -45.4 345.2 -118.7 320.8C-192 296.4 -255.8 240.5 -289.2 172.1C-322.7 103.7 -325.8 22.8 -312.4 -55.4C-299 -133.7 -269.1 -209.3 -214.2 -236C-159.4 -262.6 -79.7 -240.3 -6.3 -232.8C67.1 -225.3 134.1 -232.5 157.2 -200.3;
          M119.7 -133.8C179.1 -92.8 267.8 -77.8 298.2 -33.6C328.6 10.6 300.7 84 254.2 129.9C207.6 175.8 142.5 194.1 86.2 197.6C29.9 201.1 -17.6 189.8 -84.6 185.7C-151.6 181.5 -238.2 184.5 -283.5 144.9C-328.8 105.2 -332.8 22.9 -297.4 -30.7C-262 -84.3 -187.3 -109.2 -131.1 -150.8C-75 -192.4 -37.5 -250.7 -3.7 -246.3C30.1 -241.9 60.3 -174.8 119.7 -133.8;
        M203.4 -227.4C264.9 -190.7 317.1 -127.9 302 -74C286.8 -20 204.3 25.2 153.7 66.3C103.2 107.3 84.6 144.3 51.8 166.9C19 189.5 -27.9 197.6 -91.3 197.7C-154.7 197.7 -234.5 189.6 -282 144.7C-329.4 99.9 -344.4 18.2 -323.8 -49.9C-303.3 -118.1 -247.1 -172.8 -187.2 -209.7C-127.3 -246.7 -63.6 -265.8 3.6 -270.2C70.9 -274.5 141.8 -264 203.4 -227.4;
        M91.2 -135.8C114.3 -89.3 126.4 -56.9 140 -18.9C153.5 19.1 168.6 62.5 155.1 92.9C141.6 123.3 99.5 140.6 47.5 181.6C-4.4 222.7 -66.4 287.5 -113.6 283C-160.8 278.4 -193.4 204.5 -223.1 136.7C-252.8 69 -279.5 7.5 -268.6 -46.2C-257.7 -99.8 -209.2 -145.7 -158.2 -187.2C-107.1 -228.7 -53.6 -265.8 -9.7 -254.2C34.1 -242.6 68.1 -182.2 91.2 -135.8;

        "
                      />
                    </path>
                  </g>
                </svg>
                <svg viewBox="0 0 1000 700">
                  <g transform="translate(451.92721009196407 284.67519738484)">
                    <path fill="#008000">
                      <animate
                        attributeName="d"
                        dur="25000ms"
                        repeatCount="indefinite"
                        begin="0.9s"
                        values="
                          M140.9 -159.4C176.3 -138.1 194.5 -87.8 208 -33.4C221.5 21 230.3 79.5 211.2 130.9C192.2 182.2 145.3 226.4 86.6 255.3C27.9 284.1 -42.6 297.6 -79.4 264.2C-116.1 230.8 -118.9 150.6 -161.6 87.9C-204.3 25.2 -286.8 -20 -289.2 -58.8C-291.6 -97.5 -213.9 -130 -152.4 -146.6C-90.8 -163.3 -45.4 -164.1 3.6 -168.5C52.7 -172.8 105.4 -180.6 140.9 -159.4;
        M139.6 -169.8C183.3 -129.8 222.6 -88 231.3 -40.6C239.9 6.9 217.8 59.9 182.2 89.7C146.5 119.4 97.3 125.8 53.6 137.3C9.9 148.9 -28.2 165.6 -89.6 174.4C-151 183.2 -235.7 184.1 -286.2 142.9C-336.7 101.6 -353 18.3 -330.8 -49.7C-308.6 -117.7 -247.8 -170.3 -186.3 -207.1C-124.7 -243.9 -62.4 -265 -7.2 -256.4C48 -247.9 96 -209.7 139.6 -169.8;
        M131.5 -172.3C154.6 -137.3 146.5 -80.9 141.7 -35.7C136.8 9.4 135.1 43.2 127.6 90C120 136.8 106.7 196.7 68.9 226.6C31.1 256.5 -31.1 256.5 -100.8 245C-170.5 233.5 -247.6 210.5 -292.8 157C-338 103.6 -351.2 19.7 -318.7 -37.4C-286.2 -94.4 -208 -124.6 -147.3 -152.9C-86.6 -181.2 -43.3 -207.6 5.5 -214.1C54.2 -220.6 108.4 -207.2 131.5 -172.3;
        M113.4 -119C166.6 -90.6 242.9 -73.4 255.1 -39.7C267.3 -6 215.5 44.2 182 107.8C148.6 171.4 133.5 248.3 91.8 272C50.2 295.7 -18 266.2 -78.4 235.6C-138.9 204.9 -191.5 172.9 -238.7 122.6C-285.9 72.3 -327.6 3.6 -324.7 -65C-321.8 -133.5 -274.4 -202 -212.8 -229C-151.3 -255.9 -75.6 -241.5 -22.8 -214.4C30.1 -187.2 60.3 -147.5 113.4 -119;
        M169.4 -197.1C230 -151.1 296.7 -107.6 317 -47.7C337.2 12.1 311.1 88.3 271.9 157.7C232.7 227.1 180.5 289.8 125 284.4C69.5 279 10.7 205.6 -43.9 166C-98.5 126.4 -148.8 120.7 -172 93.2C-195.2 65.7 -191.1 16.3 -191.6 -42.9C-192 -102.2 -196.9 -171.4 -165.7 -222.5C-134.6 -273.7 -67.3 -306.8 -6.4 -299.2C54.4 -291.5 108.8 -243.1 169.4 -197.1;
        M157.2 -200.3C180.3 -168 159.4 -96.2 174.1 -28.4C188.7 39.4 239 103.2 236 162.4C233 221.6 176.7 276.2 107.1 307.1C37.5 338 -45.4 345.2 -118.7 320.8C-192 296.4 -255.8 240.5 -289.2 172.1C-322.7 103.7 -325.8 22.8 -312.4 -55.4C-299 -133.7 -269.1 -209.3 -214.2 -236C-159.4 -262.6 -79.7 -240.3 -6.3 -232.8C67.1 -225.3 134.1 -232.5 157.2 -200.3;
          M119.7 -133.8C179.1 -92.8 267.8 -77.8 298.2 -33.6C328.6 10.6 300.7 84 254.2 129.9C207.6 175.8 142.5 194.1 86.2 197.6C29.9 201.1 -17.6 189.8 -84.6 185.7C-151.6 181.5 -238.2 184.5 -283.5 144.9C-328.8 105.2 -332.8 22.9 -297.4 -30.7C-262 -84.3 -187.3 -109.2 -131.1 -150.8C-75 -192.4 -37.5 -250.7 -3.7 -246.3C30.1 -241.9 60.3 -174.8 119.7 -133.8;
        M203.4 -227.4C264.9 -190.7 317.1 -127.9 302 -74C286.8 -20 204.3 25.2 153.7 66.3C103.2 107.3 84.6 144.3 51.8 166.9C19 189.5 -27.9 197.6 -91.3 197.7C-154.7 197.7 -234.5 189.6 -282 144.7C-329.4 99.9 -344.4 18.2 -323.8 -49.9C-303.3 -118.1 -247.1 -172.8 -187.2 -209.7C-127.3 -246.7 -63.6 -265.8 3.6 -270.2C70.9 -274.5 141.8 -264 203.4 -227.4;
        M91.2 -135.8C114.3 -89.3 126.4 -56.9 140 -18.9C153.5 19.1 168.6 62.5 155.1 92.9C141.6 123.3 99.5 140.6 47.5 181.6C-4.4 222.7 -66.4 287.5 -113.6 283C-160.8 278.4 -193.4 204.5 -223.1 136.7C-252.8 69 -279.5 7.5 -268.6 -46.2C-257.7 -99.8 -209.2 -145.7 -158.2 -187.2C-107.1 -228.7 -53.6 -265.8 -9.7 -254.2C34.1 -242.6 68.1 -182.2 91.2 -135.8;

        "
                      />
                    </path>
                  </g>
                </svg>

                <div className="hero_img">
                  <img src="images/hero1.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          {/* short about section */}

          <div className="short-about text-align-center">
            <div className="about_picture">
              <svg viewBox="0 0 1000 700">
                <g transform="translate(451.92721009196407 284.67519738484)">
                  <path fill="#008000">
                    <animate
                      attributeName="d"
                      dur="25000ms"
                      repeatCount="indefinite"
                      begin="0.9s"
                      values="
                          M140.9 -159.4C176.3 -138.1 194.5 -87.8 208 -33.4C221.5 21 230.3 79.5 211.2 130.9C192.2 182.2 145.3 226.4 86.6 255.3C27.9 284.1 -42.6 297.6 -79.4 264.2C-116.1 230.8 -118.9 150.6 -161.6 87.9C-204.3 25.2 -286.8 -20 -289.2 -58.8C-291.6 -97.5 -213.9 -130 -152.4 -146.6C-90.8 -163.3 -45.4 -164.1 3.6 -168.5C52.7 -172.8 105.4 -180.6 140.9 -159.4;
        M139.6 -169.8C183.3 -129.8 222.6 -88 231.3 -40.6C239.9 6.9 217.8 59.9 182.2 89.7C146.5 119.4 97.3 125.8 53.6 137.3C9.9 148.9 -28.2 165.6 -89.6 174.4C-151 183.2 -235.7 184.1 -286.2 142.9C-336.7 101.6 -353 18.3 -330.8 -49.7C-308.6 -117.7 -247.8 -170.3 -186.3 -207.1C-124.7 -243.9 -62.4 -265 -7.2 -256.4C48 -247.9 96 -209.7 139.6 -169.8;
        M131.5 -172.3C154.6 -137.3 146.5 -80.9 141.7 -35.7C136.8 9.4 135.1 43.2 127.6 90C120 136.8 106.7 196.7 68.9 226.6C31.1 256.5 -31.1 256.5 -100.8 245C-170.5 233.5 -247.6 210.5 -292.8 157C-338 103.6 -351.2 19.7 -318.7 -37.4C-286.2 -94.4 -208 -124.6 -147.3 -152.9C-86.6 -181.2 -43.3 -207.6 5.5 -214.1C54.2 -220.6 108.4 -207.2 131.5 -172.3;
        M113.4 -119C166.6 -90.6 242.9 -73.4 255.1 -39.7C267.3 -6 215.5 44.2 182 107.8C148.6 171.4 133.5 248.3 91.8 272C50.2 295.7 -18 266.2 -78.4 235.6C-138.9 204.9 -191.5 172.9 -238.7 122.6C-285.9 72.3 -327.6 3.6 -324.7 -65C-321.8 -133.5 -274.4 -202 -212.8 -229C-151.3 -255.9 -75.6 -241.5 -22.8 -214.4C30.1 -187.2 60.3 -147.5 113.4 -119;
        M169.4 -197.1C230 -151.1 296.7 -107.6 317 -47.7C337.2 12.1 311.1 88.3 271.9 157.7C232.7 227.1 180.5 289.8 125 284.4C69.5 279 10.7 205.6 -43.9 166C-98.5 126.4 -148.8 120.7 -172 93.2C-195.2 65.7 -191.1 16.3 -191.6 -42.9C-192 -102.2 -196.9 -171.4 -165.7 -222.5C-134.6 -273.7 -67.3 -306.8 -6.4 -299.2C54.4 -291.5 108.8 -243.1 169.4 -197.1;
        M157.2 -200.3C180.3 -168 159.4 -96.2 174.1 -28.4C188.7 39.4 239 103.2 236 162.4C233 221.6 176.7 276.2 107.1 307.1C37.5 338 -45.4 345.2 -118.7 320.8C-192 296.4 -255.8 240.5 -289.2 172.1C-322.7 103.7 -325.8 22.8 -312.4 -55.4C-299 -133.7 -269.1 -209.3 -214.2 -236C-159.4 -262.6 -79.7 -240.3 -6.3 -232.8C67.1 -225.3 134.1 -232.5 157.2 -200.3;
          M119.7 -133.8C179.1 -92.8 267.8 -77.8 298.2 -33.6C328.6 10.6 300.7 84 254.2 129.9C207.6 175.8 142.5 194.1 86.2 197.6C29.9 201.1 -17.6 189.8 -84.6 185.7C-151.6 181.5 -238.2 184.5 -283.5 144.9C-328.8 105.2 -332.8 22.9 -297.4 -30.7C-262 -84.3 -187.3 -109.2 -131.1 -150.8C-75 -192.4 -37.5 -250.7 -3.7 -246.3C30.1 -241.9 60.3 -174.8 119.7 -133.8;
        M203.4 -227.4C264.9 -190.7 317.1 -127.9 302 -74C286.8 -20 204.3 25.2 153.7 66.3C103.2 107.3 84.6 144.3 51.8 166.9C19 189.5 -27.9 197.6 -91.3 197.7C-154.7 197.7 -234.5 189.6 -282 144.7C-329.4 99.9 -344.4 18.2 -323.8 -49.9C-303.3 -118.1 -247.1 -172.8 -187.2 -209.7C-127.3 -246.7 -63.6 -265.8 3.6 -270.2C70.9 -274.5 141.8 -264 203.4 -227.4;
        M91.2 -135.8C114.3 -89.3 126.4 -56.9 140 -18.9C153.5 19.1 168.6 62.5 155.1 92.9C141.6 123.3 99.5 140.6 47.5 181.6C-4.4 222.7 -66.4 287.5 -113.6 283C-160.8 278.4 -193.4 204.5 -223.1 136.7C-252.8 69 -279.5 7.5 -268.6 -46.2C-257.7 -99.8 -209.2 -145.7 -158.2 -187.2C-107.1 -228.7 -53.6 -265.8 -9.7 -254.2C34.1 -242.6 68.1 -182.2 91.2 -135.8;

        "
                    />
                  </path>
                </g>
              </svg>
              <svg viewBox="0 0 1000 700">
                <g transform="translate(451.92721009196407 284.67519738484)">
                  <path fill="#008000">
                    <animate
                      attributeName="d"
                      dur="25000ms"
                      repeatCount="indefinite"
                      begin="0.9s"
                      values="
                          M140.9 -159.4C176.3 -138.1 194.5 -87.8 208 -33.4C221.5 21 230.3 79.5 211.2 130.9C192.2 182.2 145.3 226.4 86.6 255.3C27.9 284.1 -42.6 297.6 -79.4 264.2C-116.1 230.8 -118.9 150.6 -161.6 87.9C-204.3 25.2 -286.8 -20 -289.2 -58.8C-291.6 -97.5 -213.9 -130 -152.4 -146.6C-90.8 -163.3 -45.4 -164.1 3.6 -168.5C52.7 -172.8 105.4 -180.6 140.9 -159.4;
        M139.6 -169.8C183.3 -129.8 222.6 -88 231.3 -40.6C239.9 6.9 217.8 59.9 182.2 89.7C146.5 119.4 97.3 125.8 53.6 137.3C9.9 148.9 -28.2 165.6 -89.6 174.4C-151 183.2 -235.7 184.1 -286.2 142.9C-336.7 101.6 -353 18.3 -330.8 -49.7C-308.6 -117.7 -247.8 -170.3 -186.3 -207.1C-124.7 -243.9 -62.4 -265 -7.2 -256.4C48 -247.9 96 -209.7 139.6 -169.8;
        M131.5 -172.3C154.6 -137.3 146.5 -80.9 141.7 -35.7C136.8 9.4 135.1 43.2 127.6 90C120 136.8 106.7 196.7 68.9 226.6C31.1 256.5 -31.1 256.5 -100.8 245C-170.5 233.5 -247.6 210.5 -292.8 157C-338 103.6 -351.2 19.7 -318.7 -37.4C-286.2 -94.4 -208 -124.6 -147.3 -152.9C-86.6 -181.2 -43.3 -207.6 5.5 -214.1C54.2 -220.6 108.4 -207.2 131.5 -172.3;
        M113.4 -119C166.6 -90.6 242.9 -73.4 255.1 -39.7C267.3 -6 215.5 44.2 182 107.8C148.6 171.4 133.5 248.3 91.8 272C50.2 295.7 -18 266.2 -78.4 235.6C-138.9 204.9 -191.5 172.9 -238.7 122.6C-285.9 72.3 -327.6 3.6 -324.7 -65C-321.8 -133.5 -274.4 -202 -212.8 -229C-151.3 -255.9 -75.6 -241.5 -22.8 -214.4C30.1 -187.2 60.3 -147.5 113.4 -119;
        M169.4 -197.1C230 -151.1 296.7 -107.6 317 -47.7C337.2 12.1 311.1 88.3 271.9 157.7C232.7 227.1 180.5 289.8 125 284.4C69.5 279 10.7 205.6 -43.9 166C-98.5 126.4 -148.8 120.7 -172 93.2C-195.2 65.7 -191.1 16.3 -191.6 -42.9C-192 -102.2 -196.9 -171.4 -165.7 -222.5C-134.6 -273.7 -67.3 -306.8 -6.4 -299.2C54.4 -291.5 108.8 -243.1 169.4 -197.1;
        M157.2 -200.3C180.3 -168 159.4 -96.2 174.1 -28.4C188.7 39.4 239 103.2 236 162.4C233 221.6 176.7 276.2 107.1 307.1C37.5 338 -45.4 345.2 -118.7 320.8C-192 296.4 -255.8 240.5 -289.2 172.1C-322.7 103.7 -325.8 22.8 -312.4 -55.4C-299 -133.7 -269.1 -209.3 -214.2 -236C-159.4 -262.6 -79.7 -240.3 -6.3 -232.8C67.1 -225.3 134.1 -232.5 157.2 -200.3;
          M119.7 -133.8C179.1 -92.8 267.8 -77.8 298.2 -33.6C328.6 10.6 300.7 84 254.2 129.9C207.6 175.8 142.5 194.1 86.2 197.6C29.9 201.1 -17.6 189.8 -84.6 185.7C-151.6 181.5 -238.2 184.5 -283.5 144.9C-328.8 105.2 -332.8 22.9 -297.4 -30.7C-262 -84.3 -187.3 -109.2 -131.1 -150.8C-75 -192.4 -37.5 -250.7 -3.7 -246.3C30.1 -241.9 60.3 -174.8 119.7 -133.8;
        M203.4 -227.4C264.9 -190.7 317.1 -127.9 302 -74C286.8 -20 204.3 25.2 153.7 66.3C103.2 107.3 84.6 144.3 51.8 166.9C19 189.5 -27.9 197.6 -91.3 197.7C-154.7 197.7 -234.5 189.6 -282 144.7C-329.4 99.9 -344.4 18.2 -323.8 -49.9C-303.3 -118.1 -247.1 -172.8 -187.2 -209.7C-127.3 -246.7 -63.6 -265.8 3.6 -270.2C70.9 -274.5 141.8 -264 203.4 -227.4;
        M91.2 -135.8C114.3 -89.3 126.4 -56.9 140 -18.9C153.5 19.1 168.6 62.5 155.1 92.9C141.6 123.3 99.5 140.6 47.5 181.6C-4.4 222.7 -66.4 287.5 -113.6 283C-160.8 278.4 -193.4 204.5 -223.1 136.7C-252.8 69 -279.5 7.5 -268.6 -46.2C-257.7 -99.8 -209.2 -145.7 -158.2 -187.2C-107.1 -228.7 -53.6 -265.8 -9.7 -254.2C34.1 -242.6 68.1 -182.2 91.2 -135.8;

        "
                    />
                  </path>
                </g>
              </svg>

              <div className="about_img">
                <img src="images/sabout.png" alt="" />
              </div>
            </div>
            <div className="about_text ">
              <p>I'm a designer</p>
              <h1>
                I Can Design AnyThing <br />
                You Want
              </h1>
              <h3>
                Hi, I'm Shiblu an undergraduate student of Daffodil
                International University, Dhaka ,Studying computer science and
                engineering. I am highly proficient in Java, JavaScript ,C and
                many other programming languages. I'm also MERN stack developer.
                I am capable to make web Designing using HTML5,CSS, JAVASCRIPT,
                BOOTSTRAP, ( REACT JS) etc...
              </h3>
              <br />
              <button className="learn-more" onClick={AboutHandlar}>
                <span>Learn More</span>
              </button>
            </div>
          </div>

          {/* short service  282A3A 20262E 2C3333 2D2727 272829 252B48 */}
          <div className="short_service">
            <div className="  ">
              <div className="short-service-title text-center">
                <h3>What I Do for Clients</h3>
                <span>Services/features</span>
                <p>
                  Most common methods for designing websites that work well on
                  desktop is <br /> responsive and adaptive design
                </p>
              </div>
              <div className="service_box">
                <div className="row">
                  {service.slice(0, 3).map((item) => {
                    return (
                      <SService
                        key={item.id}
                        service={item}
                        ToggleModal={() => ToggleModal(item)}
                      />
                    );
                  })}
                </div>
              </div>

              <Modal className="my-5" isOpen={modalOpen}>
                <div className="card">
                  <ModalBody>{serviceDetail}</ModalBody>
                </div>

                <ModalFooter>
                  <Button onClick={ToggleModal}> Cancel</Button>
                </ModalFooter>
              </Modal>
              <div className="short-service-button d-flex justify-content-center">
                <button
                  onClick={serviceHandelChange}
                  style={{ marginTop: "40px" }}
                >
                  View More
                </button>
              </div>
            </div>
          </div>

          {/*  short blog  */}
          <div className="blog_sec">
            <div className="container-fluid">
              <div className="blog-title text-center">
                <span>From My Blog</span>
                <h3>
                  Our Recent Updates, Blog, Tips, <br /> Tricks &amp; More
                </h3>
              </div>
              <div className="short-blog ">
                <div className=" row">
                  <div className="col-sm-12 col-md-7 col-lg-8 my-md-2  ">
                    <div className="blog-1-text px-md-5 px-2 py-3">
                      <h4> programing contest</h4>
                      <h2> CPC contest in DIU </h2>
                      <p>
                        Recently, I had the opportunity to participate in a CPC
                        (Certified Professional Coder) contest hosted by
                        Daffodil International University. It was an exciting
                        and challenging experience, as I competed against other
                        students to see who could correctly code the most
                        medical procedures in a set amount of time..{" "}
                        <button>learn-more</button>
                      </p>
                      <div className="d-flex ">
                        <h6>ziaul haque ~</h6>
                        <span>dec-12-2022</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5  col-lg-4 my-5">
                    <div className="blog-img">
                      <img
                        src="images/cpc.jpg"
                        alt="blog"
                        style={{ height: "274px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row blog2-ownStyle">
                  <div className="col-sm-12 col-md-5  col-lg-4 my-5">
                    <div className="blog-img">
                      <img src="images/icpc.jpg" alt="blog" />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-7 col-lg-8 my-md-2  ">
                    <div className="blog-1-text px-md-5 px-2 py-3">
                      <h4> programing contest</h4>
                      <h2> CPC contest in DIU </h2>
                      <p>
                        The ICPC is a multi-tiered, team-based, programming
                        competition where teams must solve as many problems as
                        possible within a given time frame using a computer. The
                        problems are designed to challenge the limits of
                        contestants and require creativity, logic, and
                        problem-solving skills.. <button>learn-more</button>
                      </p>
                      <div className="d-flex ">
                        <h6>ziaul haque ~</h6>
                        <span>dec-12-2022</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* short testimonial page.... */}
          <div className="testimonial_sec">
            {" "}
            <div className="">
              <div className="testimonial-title text-center">
                <span>Testimonials</span>
                <h3>What My Clients Say</h3>
                <p>
                  Most common methods for designing websites that work well on
                  desktop is responsive and adaptive design
                </p>
              </div>
              <div className="testimonial">
                <Testimonial />
              </div>
            </div>
          </div>

          {/* happy clint */}
          <ScrollTrigger
            onEnter={() => setCounterOn(true)}
            onExit={() => setCounterOn(false)}
          >
            <div className="happy-clint">
              <div className="row">
                <div className="col-6 col-sm-6 col-md-6 col-lg-3 text-center">
                  <h1>
                    {" "}
                    {counterOn && (
                      <CountUp start={0} end={200} duration={2} delay={0} />
                    )}{" "}
                    +
                  </h1>
                  <p>Happy clients</p>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3 text-center">
                  <h1>
                    {counterOn && (
                      <CountUp start={0} end={100} duration={2} delay={0} />
                    )}{" "}
                    +
                  </h1>
                  <p>projects</p>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3 text-center">
                  <h1>
                    {" "}
                    {counterOn && (
                      <CountUp start={0} end={2} duration={3} delay={0} />
                    )}
                    year +
                  </h1>
                  <p>experience</p>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3 text-center">
                  <h1>
                    {" "}
                    {counterOn && (
                      <CountUp start={0} end={100} duration={2} delay={0} />
                    )}
                    +
                  </h1>
                  <p>Live work</p>
                </div>
              </div>
            </div>
          </ScrollTrigger>
        </OpacityLoading>
      </div>
    </>
  );
}

export default Home;
